import { Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { WorkNews } from '@work-frontend-monorepo/work-rest-api';
import { FormatDatePipe, PrependServerToFileSrcPipe } from '@work-frontend-monorepo/work-ui/pipes';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'sfg-app-mitteilungen-card',
  templateUrl: './mitteilungen-card.component.html',
  styleUrls: ['./mitteilungen-card.component.scss'],
  standalone: true,
  imports: [ReactiveFormsModule, PrependServerToFileSrcPipe, FormatDatePipe, TranslatePipe],
})
export class MitteilungenCardComponent {
  news = input.required<WorkNews>();
  showText = input<boolean>(false);
}
